import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import { ROUTES_MPTT_QUERY, PAGE_INFORMATION_QUERY } from 'Graph/SiteGraph';
import Storage from 'src/utils/storage/storage';
import AllAlerts from 'Components/alerts/all/AllAlerts';
import UnreadAlerts from 'Components/alerts/unread/UnreadAlerts';
import AlertSettings from 'Components/alerts/settings/AlertSettings';
import SubMenu from 'Components/menu/submenu';
import { ENDPOINTS } from 'src/constants';
import PageLoadingSkeleton from 'Components/skeletons/PageLoadingSkeleton';

const KeysToComponentMap = {
  allalerts: <AllAlerts />,
  unreadalerts: <UnreadAlerts />,
  readalerts: <AlertSettings />
};

function Alerts() {
  const location = useLocation();
  const [subMenuMPTTData, setSubMenuMPTTData] = useState(null);

  // local state for source id
  const [sourceIdValue, setSourceIdValue] = useState(
    Storage.getSourceId().source
  );

  const [getLazyMPTTPages, lazyMPTTPages] = useLazyQuery(ROUTES_MPTT_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only', // Used for first execution
    nextFetchPolicy: 'cache-first' // Used for subsequent executions
  });

  useEffect(() => {
    getLazyMPTTPages({
      variables: {
        sidebar: true,
        reqNodeName: 'SRM',
        level: 2,
        sourceId: sourceIdValue.toString()
      },
      onCompleted: (pageData) => {
        // console.log("this is mptt settings data🍇🍇🍇", pageData)
        const defaultPageList = pageData.defaultRoutesMptt;
        const appPageList = pageData.appRoutesMptt;
        const pageList = [...defaultPageList, ...appPageList];
        const dedupedData = _.uniqWith(pageList, _.isEqual).filter(
          (item) => item
        );
        dedupedData.map((menu) => {
          if (menu.pages) {
            const menuItem = menu.pages;
            // console.log("this is mptt settings data🍇🍇", menuItem)
            menuItem.map((page) => {
              // console.log("this is mptt settings data🍇", page)
              if (page.sidebarUrl == location.pathname) {
                // console.log("sidebar url matches location url, checking if submenu available 🍉🍉🍉")
                setSubMenuMPTTData(page.subPages);
              }
            });
          }
          // })
        });
      }
    });
  }, [sourceIdValue]);

  const [pageInformationData, setPageInformationData] = useState(null);
  const [getLazyPageInformation, lazyPageInformation] = useLazyQuery(
    PAGE_INFORMATION_QUERY,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only', // Used for first execution
      nextFetchPolicy: 'cache-first' // Used for subsequent executions
    }
  );
  useEffect(() => {
    getLazyPageInformation({
      variables: { sidebarURL: location.pathname },
      onCompleted: (info) => {
        setPageInformationData(info.pageConn.edges.map((edge) => edge.node));
      }
    });
  }, []);
  if (pageInformationData === null)
    return (
      <PageLoadingSkeleton
        variant='rectangular'
        marginx={0}
        marginy={0}
        count={1}
        height={500}
      />
    );

  return (
    <React.StrictMode>
      <Helmet>
        <title>Alerts</title>
      </Helmet>
      <Stack direction='row' spacing={2}>
        <SubMenu
          data={subMenuMPTTData}
          rootURL={`${ENDPOINTS.alertsUrl}`}
          componentMap={KeysToComponentMap}
          label='Alerts'
          loading={lazyMPTTPages.loading}
        />
      </Stack>
    </React.StrictMode>
  );
}

export default Alerts;
